import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PageTitleScript from "@/components/MetaScript";
import { Button } from "@/components/ui/button";

const NotFoundPage = () => {
  return (
    <main className="min-h-screen flex flex-col items-center justify-center font-sans p-4 bg-bg-light">
      <PageTitleScript title="404 - Page Not Found" />
      <div className="max-w-md w-full text-center text-tx-dark">
        {/* 404 Display */}
        <div className="mb-8 relative">
          <span className="text-8xl font-extrabold text-tx-dark">404</span>
        </div>

        <h1 className="text-3xl font-bold mb-3 text-tx-dark">Page not found</h1>

        <p className="mb-8 text-tx-default">
          The page you're looking for doesn't exist or has been moved.
        </p>

        <div className="flex justify-center space-y-4 sm:space-y-0 sm:space-x-4">
          <Button
            variant="primary"
            size="lg"
            className="gap-2 rounded-full shadow-xs"
          >
            <Link to="/" className="flex items-center gap-2">
              <ArrowLeft size={16} />
              <span>Back to home</span>
            </Link>
          </Button>
        </div>
      </div>
    </main>
  );
};

export default NotFoundPage;
